import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeFilter'
})
export class FilterRemovePipe implements PipeTransform {
    transform(value: any, view: boolean, attrValue: string, valueOption: string, defaultValue: string): any {
      let newValue: any = value;
      if (!view && // se non voglio visualizzare i rimossi
          value && // se le options sono valorizzate
          value.length > 0 && // se c'� almeno un valore
          value[0][valueOption] && // se esiste la chiave. Es valore.id
          (value[0][attrValue] || !value[0][attrValue]) && // se esiste il campo rimosso. Es. valore.rimosso
          (value.findIndex( f => f[attrValue] === true) >= 0)) { // se c'� almeno un campo rimosso a true
        newValue = value.filter(opt => opt[attrValue] === false || opt[valueOption] === defaultValue); // Elimino i rimossi e tengo id default
      }
      return newValue;
    }
}
